import LargeArrowRight from "../icons/LargeArrowRight";
import Skeleton from "../Skeleton/Skeleton";
import styles from "./InputUnitConversion.module.scss";

export default function InputUnitConversionSkeleton() {
  return (
    <div className={styles.InputUnitConversion}>
      <Skeleton style={{ width: 45, height: 32 }} />
      <div className={styles.arrow}>
        <LargeArrowRight />
      </div>
      <div className={styles["target-unit"]}>
        <Skeleton style={{ width: 175, height: 32 }} />
      </div>
      <div className={styles.status}>
        <Skeleton style={{ width: 100, height: 22 }} />
      </div>
    </div>
  );
}
